import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import 'vuetify/src/stylus/app.styl'
import { Ripple } from 'vuetify/lib/directives'


Vue.use(Vuetify, {
  iconfont: 'md',
  //theme:    {
    //primary: '#3f51b5',
      //secondary: '#03a9f4',
      //accent: '#00bcd4',
      //error: '#f44336',
      //warning: '#ff9800',
      //info: '#2196f3',
      //success: '#8bc34a'
  //},
  directives: {
    Ripple
  }
})
